module.exports = __webpack_public_path__ + "img/m_bg2.00d8fc43.png";